const areSameInsurance = (serverLineItem, draftLineItem)=>{
    var ref, ref1, ref2;
    if (draftLineItem.type !== 'insurance' || ((ref = serverLineItem.typeDetails) === null || ref === void 0 ? void 0 : ref.__typename) !== 'BundlePrescriptionGlassesTypeDetails') {
        return false;
    }
    return ((ref1 = serverLineItem.insurance) === null || ref1 === void 0 ? void 0 : ref1.sku) === draftLineItem.sku && serverLineItem.id === ((ref2 = draftLineItem.typeDetails) === null || ref2 === void 0 ? void 0 : ref2.lineItemId);
};

export { areSameInsurance };
//# sourceMappingURL=are-same-insurance.js.map
